import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { getIsVisibleInLocale } from "../../../services/links"
import breakpoints from "../../../styles/breakpoints"
import colors from "../../../styles/colors"
import Footer from "../../Layout/Footer"
import MobileLink from "./MobileLink"

const MobileOverlayContainer = styled.div`
  height: 100%;
  width: 100%;
  max-width: 100vw;
  position: fixed;
  height: calc(100vh - 44px);
  height: ${(props) => `calc(${props.height}px - 44px)`};
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  top: 44px;

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const MenuContainer = styled.div`
  flex: 1;
  padding-bottom: 20px;
`

const MobileOverlay = ({
  links,
  isBespokeOpen,
  setIsBespokeOpen,
  setMenuOpen,
  closeIfActive,
  alternatePath
}) => {
    const [height, setHeight] = useState(0)

    useEffect(() => {
      const handleResize = () => {
        setHeight(window.innerHeight)
      }
      handleResize()
      window.addEventListener("resize", handleResize)
      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }, [])

  return (
    <MobileOverlayContainer height={height}>
      <MenuContainer>
        {links.map((link, index) => {
          const visible = getIsVisibleInLocale(link.locale)

          if (!visible) return null

          return (
            <MobileLink
              link={link}
              isBespokeOpen={isBespokeOpen}
              setIsBespokeOpen={setIsBespokeOpen}
              setMenuOpen={setMenuOpen}
              key={index}
              closeIfActive={closeIfActive}
            />
          )
        })}
      </MenuContainer>
      <Footer alternatePath={alternatePath} overlay />
    </MobileOverlayContainer>
  )
}

export default MobileOverlay
